import { retryUnlessRateLimited } from '../utils/queryRetry'
import { useQuery } from '@tanstack/react-query'
import BillingService from '../services/billing'

/**
 * LOT-UPGRADE — etat de l'interrupteur `billing_enabled`.
 *
 * La config est un couple de booleens quasi statiques (elle ne change qu'a un
 * redeploiement backend) : cache long, une requete par session en pratique.
 */
export function useBillingConfig() {
  return useQuery({
    queryKey: ['billing', 'config'],
    queryFn: () => BillingService.getConfig(),
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    retry: retryUnlessRateLimited, // une tentative de plus, jamais sur un 429 (#194, D-G)
  })
}

/**
 * Souscription de l'utilisateur courant — sert a marquer l'offre courante sur
 * /upgrade. `enabled` : inutile d'interroger le backend quand le tunnel est
 * eteint ou que la page n'en a pas besoin.
 */
export function useSubscriptionQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['billing', 'subscription'],
    queryFn: () => BillingService.getSubscription(),
    enabled,
    staleTime: 60 * 1000,
    retry: retryUnlessRateLimited, // une tentative de plus, jamais sur un 429 (#194, D-G)
  })
}
